<template>
  <div class="dropdown">
    <div :class="{ dropdown__body_right: right }" class="dropdown__body">
      <!-- header info -->
      <slot />

      <!-- info -->
      <p v-if="info" class="dropdown-info" v-text="info" />

      <!-- items -->
      <ul v-if="menu" class="dropdown-menu">
        <li
          v-for="(item, index) in menu"
          :key="index"
          class="dropdown-menu__item"
        >
          <a :href="item.link" class="dropdown-menu__link">
            <i
              :class="`dropdown-menu__icon_${item.icon}`"
              class="dropdown-menu__icon"
            />
            <span class="dropdown-menu__text" v-text="item.title" />
          </a>
        </li>
      </ul>
      <!-- items end -->

      <!-- link -->
      <div v-if="link" class="dropdown-footer">
        <a :href="link.to" class="dropdown-footer__link"
          ><span v-text="link.text"
        /></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderDropdown",

  props: {
    info: String,
    menu: Array,
    link: Object,
    right: Boolean
  }
};
</script>

<style>
@import "./dropdown.css";
</style>
